<template>
  <b-row>

    <h2 class="pl-1">{{ $t('side_bar.category') }}</h2>

    <!--  BEFORE TABLE  -->
    <div class="d-flex justify-content-between col-12">
      <b-col
        md="4"
        class="my-1 px-0"
      >
        <b-form-group
          class="mb-0"
        >
          <b-input-group size="md">
            <b-form-input
              id="filterInput"
              v-model="filter"
              type="search"
              :placeholder="$t('reusable.search_placeholder')"
            />
            <b-input-group-append>
              <b-button
                :disabled="!filter"
                @click="filter = ''"
              >
                {{ $t('reusable.clear_btn') }}
              </b-button>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
      </b-col>

      <div
        class="my-1 float-right"
      >
        <modal-button
          ripple="rgba(113, 102, 240, 0.15)"
          size="lg"
          name="modal-main"
          :backdrop-close="true"
          :modalButton="$t('reusable.modal_add_btn')"
          @btn-emit="createNewCategory"
          @open-emit="clearData"
          :modal-title="$t('category_table.add_category_title')"
          variant="success"
        >
          <template v-slot:button @click="createNewCategory">{{ $t('reusable.modal_add_btn') }}</template>

          <template v-slot:modal-body>
            <div class="d-flex flex-wrap">

              <b-col cols="6">
                <b-form-group
                  :label="$t('category_table.add_category_label_ru')"
                  label-for="defaultLabel"
                >
                  <b-form-input
                    v-model="name.ru"
                    id="defaultLabel"
                    size="lg"
                    :placeholder="$t('category_table.add_category_label_ru')"
                  />
                </b-form-group>
              </b-col>

              <b-col cols="6">
                <b-form-group
                  :label="$t('category_table.add_category_label_uz')"
                  label-for="defaultLabel"
                >
                  <b-form-input
                    v-model="name.uz"
                    id="defaultLabel"
                    size="lg"
                    :placeholder="$t('category_table.add_category_label_uz')"
                  />
                </b-form-group>
              </b-col>

              <div class="col-12 category__select">
                <infinity-scroll-select
                  :value="specifications"
                  v-model="creation.specifications"
                  :multiple="true"
                  apiUrl="products.fetchSpec"
                  :label="$t('category_table.add_spec')"
                />
              </div>

            </div>
          </template>
        </modal-button>

      </div>
    </div>

    <!--  TABLE  -->
    <b-col cols="12">
      <b-table
        striped
        hover
        responsive
        sort-icon-left
        :busy="isBusy"
        :items="items"
        :fields="fields"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        :sort-direction="sortDirection"
        :filter="filter"
        :filter-included-fields="filterOn"

        @filtered="onFiltered"
      >
        <template v-slot:head(is_deleted)="data">
          <b-form-select
            size="md"
            v-model="status"
            class="w-100"
          >
            <template #first>
              <option
                selected
                :value="null"
              >
                Выберите статус
              </option>
            </template>
            <option
              v-for="(status, index) in statuses"
              :key="index"
              :value="status"
            >
              {{ status }}
            </option>
          </b-form-select>
        </template>

        <template #table-busy>
          <div class="text-center text-primary my-2">
            <b-spinner class="align-middle"></b-spinner>
            <strong class="ml-1">{{ $t('reusable.isBusy') }}</strong>
          </div>
        </template>

        <template #cell(is_deleted)="data">
          <b-badge :variant="changeVariant(data.item)">
            {{ data.item.is_deleted }}
          </b-badge>
        </template>

        <template #cell(name)="data">
          {{ checkLocales(data.item.name) }}
        </template>

        <template #cell(crud_row)="data">
          <div class="d-flex float-right">

            <b-dropdown
              no-caret
              id="table-action-dropdown"
              variant="link"
              size="md"
            >
              <template
                #button-content
                class="p-0"
              >
                <feather-icon
                  icon="MoreVerticalIcon"
                  class="p-0"
                />
              </template>

              <!--   PREVIEW BUTTON   -->
              <b-dropdown-item
                class="px-0"
              >
                <modal-button
                  ripple="rgba(113, 102, 240, 0.15)"
                  size="xl"
                  :name="`modal-preview-${data.item.id}`"
                  :backdrop-close="true"
                  :modalButton="$t('region_table.country_edit_modal_title')"
                  :id="data.item.id"
                  :hide-footer="true"
                  :modal-title="$t('reusable.preview_btn')"
                  :disableButton="!editAllow"
                  variant="flat-primary"
                  @open-emit="getCategoryById(data.item.id)"
                  @btn-emit="updateCategory(data.item.id, data.item)"
                >
                  <template
                    v-slot:button
                    style="width: 100% !important;"
                  >
                    <div class="d-flex align-items-center">
                      <feather-icon
                        icon="EyeIcon"
                        size="21"
                        style="margin-right: 6px"
                      />
                      <span>{{ $t('reusable.preview_btn') }}</span>
                    </div>
                  </template>

                  <template v-slot:modal-body>

                    <div class="d-flex flex-wrap">

                      <b-col cols="4">
                        <b-form-group
                          :label="$t('category_table.add_category_label_ru')"
                          label-for="defaultLabel"
                        >
                          <b-form-input
                            v-model="data.item.name.ru"
                            id="defaultLabel"
                            size="lg"
                            :disabled="!editAllow"
                            :placeholder="$t('category_table.add_category_label_ru')"
                          />
                        </b-form-group>
                      </b-col>

                      <b-col cols="4">
                        <b-form-group
                          :label="$t('category_table.add_category_label_uz')"
                          label-for="defaultLabel"
                        >
                          <b-form-input
                            v-model="data.item.name.uz"
                            id="defaultLabel"
                            size="lg"
                            :disabled="!editAllow"
                            :placeholder="$t('category_table.add_category_label_uz')"
                          />
                        </b-form-group>
                      </b-col>

                      <b-col cols="4">
                        <infinity-scroll-select
                          apiUrl="products.fetchSpec"
                          :disabled="!editAllow"
                          v-model="data.item.specifications"
                          :multiple="true"
                          :label="$t('category_table.add_spec')"
                        />
                      </b-col>

                      <b-col cols="4">
                        <b-form-group
                          :label="$t('region_table.created_at')"
                          label-for="defaultLabel"
                        >
                          <b-form-input
                            v-model="createdAt"
                            id="defaultLabel"
                            size="lg"
                            :disabled="!editAllow"
                            :placeholder="$t('region_table.created_at')"
                          />
                        </b-form-group>
                      </b-col>

                      <b-col cols="4">
                        <b-form-group
                          :label="$t('region_table.updated_at')"
                          label-for="defaultLabel"
                        >
                          <b-form-input
                            v-model="updatedAt"
                            id="defaultLabel"
                            size="lg"
                            :disabled="!editAllow"
                            :placeholder="$t('region_table.updated_at')"
                          />
                        </b-form-group>
                      </b-col>

                    </div>

                  </template>


                </modal-button>
              </b-dropdown-item>

              <!--  EDIT BUTTON  -->
              <b-dropdown-item
                class="px-0"
              >
                <modal-button
                  ripple="rgba(113, 102, 240, 0.15)"
                  size="xl"
                  :backdrop-close="true"
                  :name="`modal-edit-${data.item.id}`"
                  :modalButton="$t('reusable.save_btn')"
                  :id="data.item.id"
                  :modal-title="$t('reusable.modal_edit_btn')"
                  variant="flat-warning"
                  @btn-emit="updateCategory(data.item.id, data.item)"
                >
                  <template
                    v-slot:button
                    style="width: 100% !important;"
                  >
                    <div class="d-flex align-items-center">
                      <feather-icon
                        icon="Edit2Icon"
                        size="21"
                        style="margin-right: 6px"
                      />
                      <span>{{ $t('reusable.modal_edit_btn') }}</span>
                    </div>
                  </template>

                  <template v-slot:modal-body>
                    <div class="d-flex flex-wrap">

                      <b-col cols="4">
                        <b-form-group
                          :label="$t('category_table.add_category_label_ru')"
                          label-for="defaultLabel"
                        >
                          <b-form-input
                            v-model="data.item.name.ru"
                            id="defaultLabel"
                            size="lg"
                            :placeholder="$t('category_table.add_category_label_ru')"
                          />
                        </b-form-group>
                      </b-col>

                      <b-col cols="4">
                        <b-form-group
                          :label="$t('category_table.add_category_label_uz')"
                          label-for="defaultLabel"
                        >
                          <b-form-input
                            v-model="data.item.name.uz"
                            id="defaultLabel"
                            size="lg"
                            :placeholder="$t('category_table.add_category_label_uz')"
                          />
                        </b-form-group>
                      </b-col>

                      <b-col cols="4">
                        <infinity-scroll-select
                          apiUrl="products.fetchSpec"
                          v-model="data.item.specifications"
                          :multiple="true"
                          :label="$t('category_table.add_spec')"
                        />
                      </b-col>

                    </div>

                  </template>

                </modal-button>
              </b-dropdown-item>

              <!--  DELETE BUTTON  -->
              <b-dropdown-item>
                <modal-button
                  ripple="rgba(113, 102, 240, 0.15)"
                  size="sm"
                  :name="`modal-delete-${data.item.id}`"
                  :modalButton="$t('region_table.country_delete_modal_title')"
                  :modal-title="$t('region_table.country_delete_modal_title')"
                  variant="flat-danger"
                  :id="data.item.id"
                  @btn-emit="deleteCategory"
                >
                  <template v-slot:button class="w-100">
                    <div class="d-flex align-items-center">
                      <feather-icon
                        icon="Trash2Icon"
                        size="21"
                        style="margin-right: 6px"
                      />
                      <span>{{ $t('reusable.modal_delete_btn') }}</span>
                    </div>
                  </template>

                  <template v-slot:modal-body>
                    <div class="my-2">
                      {{ $t('category_table.delete_category_text') }}
                    </div>
                  </template>

                </modal-button>
              </b-dropdown-item>

            </b-dropdown>

          </div>
        </template>
      </b-table>
    </b-col>

    <!--  PAGINATION  -->
    <b-col
      cols="12"
    >
      <b-pagination
        v-if="showPagination"
        v-model="pagination.current"
        :total-rows="pagination.total"
        :per-page="pagination.per_page"
        align="center"
        size="sm"
        class="my-0"
      />
    </b-col>
  </b-row>
</template>

<script>
import {
  BTable,
  BBadge,
  BRow,
  BCol,
  BFormGroup,
  BFormSelect,
  BPagination,
  BInputGroup,
  BFormInput,
  BInputGroupAppend,
  BButton,
  BDropdown,
  BDropdownItem,
  BFormCheckbox,
  BSpinner
} from 'bootstrap-vue'
import ModalButton from '@/views/ui/modals/ModalButton.vue'
import api from '@/services/api'
import InfinityScrollSelect from '@/views/ui/infinity-scroll/InfinityScrollSelect'

export default {
  components: {
    BTable,
    BBadge,
    BRow,
    BCol,
    BFormGroup,
    BFormSelect,
    BPagination,
    BInputGroup,
    BFormInput,
    BInputGroupAppend,
    BButton,
    BDropdown,
    BDropdownItem,
    BFormCheckbox,
    BSpinner,
    ModalButton,
    InfinityScrollSelect
  },
  data() {
    // const query = Object.assign({}, this.$route.query)

    return {
      createdAt: '',
      updatedAt: '',
      editAllow: false,
      specifications: {},
      sortBy: '',
      sortDesc: false,
      sortDirection: 'asc',
      filter: null,
      filterOn: [],
      status: null,
      infoModal: {
        id: 'info-modal',
        title: '',
        content: '',
      },
      statuses: [true, false],
      fields: [
        {
          key: 'id',
          label: 'ID',
        },
        {
          key: 'name',
          label: this.$t('category_table.category_name'),
          sortable: true,
        },
        {
          key: 'created_at',
          label: this.$t('region_table.created_at'),
        },
        {
          key: 'updated_at',
          label: this.$t('region_table.updated_at'),
        },
        {
          key: 'crud_row',
          label: ' ',
        },
      ],
      variant: '',
      items: [],
      name: {
        ru: '',
        uz: '',
      },
      isBusy: false,
      pagination: {
        current: 1,
        total: 1,
        per_page: 5
      },
      creation: {
        specifications: null
      }
    }
  },
  watch: {
    '$route.query': {
      handler(query) {
        // const routeQueryPage = parseInt(query.page)
        this.pagination.current = query.page
        this.fetchCategoryList()
      },
      deep: true,
      immediate: true
    },
    'pagination.current': {
      handler(page) {
        this.replaceRouter({
          ...this.query,
          page,
        })
      },
    }
  },

  computed: {
    rows() {
      return this.items.length
    },

    query() {
      return Object.assign({}, this.$route.query)
    },

    hasItems() {
      return this.items.length > 0
    },

    showPagination() {
      return this.hasItems && !this.isBusy
    },

    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter(f => f.sortable)
        .map(f => ({
          text: f.label,
          value: f.key,
        }))
    },
  },

  async created() {
    // await this.fetchCategoryList()
  },

  methods: {

    clearData() {
      this.name.ru = ''
      this.name.uz = ''
      this.specifications = null
    },

    replaceRouter(query) {
      this.$router.replace({ query })
        .catch(() => {
        })
    },

    async fetchCategoryList() {
      const data = {
        with: {
          0: 'specifications'
        },
        page: this.$route.query.page
      }
      this.isBusy = true
      await api.products.fetchCategory(data)
        .then(res => {
          this.items = res.data.data
          this.pagination.per_page = res.data.meta.per_page
          this.pagination.total = res.data.meta.total
          this.pagination.current = res.data.meta.current_page
        })
        .catch((error) => {
          console.error(error)
        })
        .finally(() => {
          this.isBusy = false
        })
    },

    async getCategoryById(id) {
      const data = {
        with: {
          0: 'specifications',
        }
      }
      this.editAllow = false
      await api.products.fetchOneCategory(id, data)
        .then(res => {
          this.createdAt = res.data.created_at
          this.updatedAt = res.data.updated_at
          this.name.ru = res.data.name.ru
          this.name.uz = res.data.name.uz
        })
        .catch((error) => {
          console.error(error)
        })
        .finally(() => {

        })
    },

    createNewCategory() {
      const data = {
        name: this.name,
        specifications: this.creation.specifications.map(({ id }) => id)
      }
      api.products.createCategory(data)
        .then(res => {
        })
        .catch((error) => {
          console.error(error)
        })
        .finally(() => {
          this.fetchCategoryList()
          // this.name.ru = ''
          // this.name.uz = ''
          // this.specifications = null
        })
    },

    updateCategory(id, data) {
      const body = {
        name: data.name,
        specifications: data.specifications.map(({ id }) => id)
      }
      api.products.updateCategory(id, body)
        .then(res => {
          this.specifications = res.data
        })
        .catch((error) => {
          console.error(error)
        })
        .finally(() => {
          this.fetchCategoryList()
        })
    },

    deleteCategory(id) {
      api.products.deleteCategory(id)
        .then(res => {
        })
        .catch((error) => {
          console.error(error)
        })
        .finally(() => {
          this.fetchCategoryList()
        })
    },

    checkLocales(value) {
      if (localStorage.lang === 'ru') {
        return value.ru
      }
      return value.uz
    },

    info(item, index, button) {
      this.infoModal.title = `Row index: ${index}`
      this.infoModal.content = JSON.stringify(item, null, 2)
      this.$root.$emit('bv::show::modal', this.infoModal.id, button)
    },

    resetInfoModal() {
      this.infoModal.title = ''
      this.infoModal.content = ''
    },

    onFiltered(filteredItems) {
      // Trigger pagination to update the number of modals/pages due to filtering
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
  },
}
</script>

<style lang="scss">

.category__select .v-select {
  height: 100px;
}

.category__select .v-select .vs__dropdown-toggle {
  height: 100%;
}

.category__select .v-select .vs__dropdown-toggle .vs__selected {
  height: 42%;
}

[dir] .dropdown-item {
  padding: 0;
}

.vs__selected-options {
  overflow-x: scroll;
}

</style>
